import 'core-js/fn/object/assign';
import 'core-js/fn/get-iterator';
import 'core-js/fn/symbol';

import Vue from 'vue'
//import BootstrapVue from
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import App from './App.vue'
import PortalVue from 'portal-vue';
//import axios from "axios";
Vue.use(PortalVue);
//Vue.use(BootstrapVue);

import { TabsPlugin, AlertPlugin, SpinnerPlugin, PaginationPlugin, TooltipPlugin, FormInputPlugin, FormCheckboxPlugin, FormDatepickerPlugin, DropdownPlugin, BootstrapVueIcons}  from 'bootstrap-vue'
import VueTour from './components/tour';

Vue.use(VueTour);
Vue.use(TabsPlugin);
Vue.use(AlertPlugin);
Vue.use(SpinnerPlugin);
Vue.use(PaginationPlugin);
Vue.use(TooltipPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(FormDatepickerPlugin);
Vue.use(DropdownPlugin);
Vue.use(BootstrapVueIcons);
//import { VTooltip} from 'v-tooltip'
//Vue.directive('tooltip', VTooltip)

/*import Hub from './hub'
Vue.use(Hub)*/


import './utils'
const isDevelopment = process.env.NODE_ENV !== 'production';

Vue.config.productionTip = false//!isDevelopment

/* if (process.env.VUE_APP_HTMLONLY) {
	let mockingEnabled = true

	const mocks = {}

	const addMock = (url, data) => {
		mocks[url] = data
	}

	const isUrlMocked = url => url in mocks

	const getMockError = config => {
		const mockError = new Error()
		mockError.mockData = mocks[config.url]
		mockError.config = config
		return Promise.reject(mockError)
	}

	const isMockError = error => Boolean(error.mockData)

	const getMockResponse = mockError => {
		const { mockData, config } = mockError
		// Handle mocked error (any non-2xx status code)
		if (mockData.status && String(mockData.status)[0] !== '2') {
			const err = new Error(mockData.message || 'mock error')
			err.code = mockData.status
			return Promise.reject(err)
		}
		// Handle mocked success
		return Promise.resolve(Object.assign({
			data: {},
			status: 200,
			statusText: 'OK',
			headers: {},
			config,
			isMock: true
		}, mockData))
	}

	// Add a request interceptor
	axios.interceptors.request.use(config => {
		if (mockingEnabled && isUrlMocked(config.url)) {
			console.log('axios mocking ' + config.url)
			return getMockError(config)
		}
		return config
	}, error => Promise.reject(error))

	// Add a response interceptor
	axios.interceptors.response.use(response => response, error => {
		if (isMockError(error)) {
			return getMockResponse(error)
		}
		return Promise.reject(error)
	})
	addMock('/api/categories/user_categories', {
		data: {
			payload: {
				categories: [{ id: 1, title: "newsletters1" }, { id: 2, title: "free" }, { id: 2, title: "paid" }],
				webinar_collections: [{ id: 2, title: "free_coll1" }, { id: 3, title: "free_coll2" }]
			}
		}
	})
	addMock('/api/blog/archive/2019', { data: [{ published: Date.now(), name: "One" }, { published: Date.now(), name: "Two" }] })
	addMock('/api/blog/category/newsletters1/page/1', {
		data: {
			responseCode: 0, payload:
			{
				items: [{ pubDate: new Date(Date.now), title: 'Test Title', slug: 'slug', excerpt: 'test excerpt' }],
				TotalNumOfAvailableItems: 1
			}
		}
	});
	addMock('/api/webinars/upcoming/collections/2/1', {
		data: {
			responseCode: 0, payload:
			{
				items: [{ start: new Date(Date.now()), end: new Date(Date.now()), subject: "Webinar Subject" },
				{ start: new Date(Date.now()), end: new Date(Date.now()), subject: "Webinar Subject 2" }
				],
				TotalNumOfAvailableItems: 1
			}
		}
	});

	addMock('/api/webinars/recorded/collections/2/1', {
		data: {
			responseCode: 0, payload:
			{
				items: [
					{ start: new Date(Date.now()), end: new Date(Date.now()), subject: "Recorded Subject", vimeoLink: 'vimeo.com/316814006' },
					{ start: new Date(Date.now()), end: new Date(Date.now()), subject: "Recorded Subject 2", vimeoLink: 'vimeo.com/316814006' }
				],
				TotalNumOfAvailableItems: 1
			}
		}
	});
} */


new Vue({ render: h => h(App), }).$mount('#VueAppRoot')

/*if (!window.dontLoadApp) {

	if (module['hot']) {
		module['hot'].accept();
	}
}*/